import { AxiosError } from 'axios';

import { PaymentClientMethod } from '@packlink/packlink-sdk';

import Packlink from '@sdk';
import { formatError } from '@utils/error';
import { ReduxDispatch, ReduxAction } from '@store';
import { setErrorAction, setLoadingAction } from '@store/actions/status';

import { DELETE_PAYMENT_CLIENT_METHOD, SET_PAYMENT_CLIENT_METHODS } from './action-types';

export interface ISetPaymentClientMethodsAction {
    type: 'SET_PAYMENT_CLIENT_METHODS';
    payload: Array<PaymentClientMethod | undefined>;
}

export interface IDeletePaymentClientMethodAction {
    type: 'DELETE_PAYMENT_CLIENT_METHOD';
    payload: PaymentClientMethod;
}

export type PaymentAction = ISetPaymentClientMethodsAction | IDeletePaymentClientMethodAction;

export const setPaymentClientMethodsAction = (
    data: Array<PaymentClientMethod | undefined>,
): ISetPaymentClientMethodsAction => ({ type: SET_PAYMENT_CLIENT_METHODS, payload: data });

export const deletePaymentClientMethodAction = (data: PaymentClientMethod): IDeletePaymentClientMethodAction => ({
    type: DELETE_PAYMENT_CLIENT_METHOD,
    payload: data,
});

export const requestPaymentsAction =
    (): ReduxAction<Promise<void>> =>
    async (dispatch: ReduxDispatch): Promise<void> => {
        dispatch(setLoadingAction({ fetchingPayments: true }));

        return Packlink.v1.billing
            .allDetails()
            .then((payments: Array<PaymentClientMethod | undefined>) => {
                dispatch(setPaymentClientMethodsAction(payments));
            })
            .catch((error: AxiosError): void => {
                const formattedError = formatError(error);
                dispatch(setErrorAction(formattedError));
                throw formattedError;
            })
            .finally(() => {
                dispatch(setLoadingAction({ fetchingPayments: false }));
            });
    };
